import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferItemsListComponent } from './offer-items-list.component';

@NgModule({
  declarations: [OfferItemsListComponent],
  imports: [CommonModule],
  exports: [OfferItemsListComponent],
})
export class OfferItemsListModule {}
